import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
	root: {},
	paperCard: {
		backgroundColor: '#e4eefb',
		color: '#15263e',
		boxShadow: 'none',
		padding: '0.632rem',
		borderRadius: '20px',
		display: 'flex',
		alignItems: 'center',
		flexShrink: 3,
		width: 'fit-content',
	},
	icon: {
		marginRight: theme.spacing(1),
	},
	itemGroup: {
		...theme.typography.link1,
	},
	cellStyle: {
		whiteSpace: 'nowrap',
	},
	linkCell: {
		width: '9rem',
	},
	linkedDate: {
		width: '15rem',
	},
	linkButton: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		maxHeight: '20px',
	},
}));
